import React from 'react';
// import { CameraIcon } from '@heroicons/react/24/outline'; // Unused - removed
import ImageUpload from '../ImageUpload';

const VesselPhotosTab = ({ vessel, onVesselUpdate, user }) => {
  const handleImagesChange = async (images) => {
    try {
      // Convert array of objects to array of strings for database compatibility
      const imageUrls = images.map(img => img.imageUrl || img);
      console.log('📸 VesselPhotosTab: Images changed, sending to backend:', imageUrls);
      console.log('📸 Primary image URL:', vessel.primary_image_url || (imageUrls.length > 0 ? imageUrls[0] : ''));
      
      const updateData = {
        image_urls: imageUrls,
        primary_image_url: vessel.primary_image_url || (imageUrls.length > 0 ? imageUrls[0] : '')
      };
      
      console.log('📸 Calling onVesselUpdate with:', updateData);
      await onVesselUpdate(updateData);
      console.log('✅ onVesselUpdate completed');
    } catch (error) {
      console.error('❌ Error updating vessel images:', error);
    }
  };

  const handlePrimaryImageChange = async (imageUrl) => {
    try {
      await onVesselUpdate({
        primary_image_url: imageUrl
      });
    } catch (error) {
      console.error('Error updating primary image:', error);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold" style={{color: '#f8fafc'}}>Photo Gallery</h2>
      </div>
      
      <div className="space-y-4">
        <p className="text-sm" style={{color: '#cbd5e1'}}>
          Upload and organize photos of your vessel, equipment, and maintenance work.
        </p>
        
        <ImageUpload
          images={(vessel.image_urls || []).map(img => {
            if (typeof img === 'string') {
              return { imageUrl: img, filename: img.split('/').pop() };
            } else if (img && img.imageUrl) {
              return img; // Already an object
            } else {
              return { imageUrl: img, filename: 'unknown' };
            }
          })}
          onImagesChange={handleImagesChange}
          primaryImageUrl={vessel.primary_image_url || ''}
          onPrimaryImageChange={handlePrimaryImageChange}
          maxImages={20}
        />
      </div>
    </div>
  );
};

export default VesselPhotosTab;
